module.exports = __webpack_public_path__ + "static/media/other2.b9834cdd.jpg";